var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"input-container"},[_vm._t("input"),_c('i',{staticClass:"icon",class:_vm.icon})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }